import { render, staticRenderFns } from "./SupplierContactForm.vue?vue&type=template&id=1a2410a6&scoped=true&"
import script from "./SupplierContactForm.vue?vue&type=script&lang=js&"
export * from "./SupplierContactForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplierContactForm.vue?vue&type=style&index=0&id=1a2410a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2410a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
